import React from 'react';
import { MainWrapper } from '../main-wrapper';
import { IComponentProps } from '../../../model/studio';
import { OrganizationContentComponent } from './organization-content';
import getFormatMessage from '../../../locales/get-format-message';
import { PermissionCheck } from '../../component/permission-check';

export const OrganizationRouter = () => {
  const renderComponent = (props: IComponentProps) => {
    return (
      <PermissionCheck contentType="page" anyPermission={true}>
        <OrganizationContentComponent {...props} />
      </PermissionCheck>
    );
  };

  return (
    <MainWrapper
      title={getFormatMessage('organization')}
      renderComponent={renderComponent}
    />
  );
};
